import {
  LIST_BRANCH_HEALTHCARE_REQUEST,
  LIST_BRANCH_HEALTHCARE_SUCCESS,
  LIST_BRANCH_HEALTHCARE_FAIL,
  LIST_HEALTHCARE_SUPPORT_REQUEST,
  LIST_HEALTHCARE_SUPPORT_SUCCESS,
  LIST_HEALTHCARE_SUPPORT_FAIL,
  LIST_MCU_TEAM_REQUEST,
  LIST_MCU_TEAM_SUCCESS,
  LIST_MCU_TEAM_FAIL,
  LIST_MCU_TEAM_SUMMARY_REQUEST,
  LIST_MCU_TEAM_SUMMARY_SUCCESS,
  LIST_MCU_TEAM_SUMMARY_FAIL,
  DETAIL_MCU_TEAM_REQUEST,
  DETAIL_MCU_TEAM_SUCCESS,
  DETAIL_MCU_TEAM_FAIL,
  CREATE_BRANCH_HEALTHCARE_REQUEST,
  CREATE_BRANCH_HEALTHCARE_SUCCESS,
  CREATE_BRANCH_HEALTHCARE_FAIL,
  UPDATE_BRANCH_HEALTHCARE_REQUEST,
  UPDATE_BRANCH_HEALTHCARE_SUCCESS,
  UPDATE_BRANCH_HEALTHCARE_FAIL,
  DETAIL_BRANCH_HEALTHCARE_REQUEST,
  DETAIL_BRANCH_HEALTHCARE_SUCCESS,
  DETAIL_BRANCH_HEALTHCARE_FAIL,
  DELETE_BRANCH_HEALTHCARE_REQUEST,
  DELETE_BRANCH_HEALTHCARE_SUCCESS,
  DELETE_BRANCH_HEALTHCARE_FAIL
} from '../../../constants/branches/branch-properties/index'

import {
  LIST_BRANCH_LAB_REQUEST,
  LIST_BRANCH_LAB_SUCCESS,
  LIST_BRANCH_LAB_FAIL
} from '../../../constants/branches'

const initialState = {
  healthCares: [],
  healthCare: {},
  mcuTeams: [],
  mcuTeamsSummary: [],
  mcuTeam: {},
  healthCareSupports: [],
  branchLab: [],
  pageable: {},
  loading: false,
  loadingCreateBatch: false,
  loadingDetail: false,
  loadingUpdate: false,
  loadingDelete: false,
  error: '',
  branchLab: []
}

const branchPropertiesReducer = (state = initialState, action) => {
  switch (action.type) {
    //** branches */
    case LIST_BRANCH_HEALTHCARE_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_HEALTHCARE_SUCCESS:
      return {
        ...state,
        loading: false,
        healthCares: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_HEALTHCARE_FAIL:
      return { ...state, loading: false, error: action.payload, mcuTeams: [] }
    case LIST_MCU_TEAM_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuTeams: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_TEAM_FAIL:
      return { ...state, loading: false, error: action.payload, mcuTeams: [] }
    case LIST_HEALTHCARE_SUPPORT_REQUEST:
      return { ...state, loading: true }
    case LIST_HEALTHCARE_SUPPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        healthCareSupports: action.payload
      }
    case LIST_HEALTHCARE_SUPPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        healthCareSupports: []
      }
    case LIST_BRANCH_LAB_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_LAB_SUCCESS:
      return {
        ...state,
        loading: false,
        branchLab: action.payload
      }
    case LIST_BRANCH_LAB_FAIL:
      return { ...state, loading: false, error: action.payload, branchLab: [] }
    case CREATE_BRANCH_HEALTHCARE_REQUEST:
      return { ...state, loadingCreateBatch: true }
    case CREATE_BRANCH_HEALTHCARE_SUCCESS:
      return { ...state, loadingCreateBatch: false }
    case CREATE_BRANCH_HEALTHCARE_FAIL:
      return { ...state, loadingCreateBatch: false, error: action.payload }
    case DETAIL_MCU_TEAM_REQUEST:
      return { ...state, loadingDetail: true, mcuTeam: {} }
    case DETAIL_MCU_TEAM_SUCCESS:
      return { ...state, loadingDetail: false, mcuTeam: action.payload }
    case DETAIL_MCU_TEAM_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case LIST_MCU_TEAM_SUMMARY_REQUEST:
      return { ...state, loadingTeamSummary: true }
    case LIST_MCU_TEAM_SUMMARY_SUCCESS:
      return { ...state, loadingTeamSummary: false, mcuTeamsSummary: action.payload }
    case LIST_MCU_TEAM_SUMMARY_FAIL:
      return { ...state, loadingTeamSummary: false, error: action.payload }
    case DETAIL_BRANCH_HEALTHCARE_REQUEST:
      return { ...state, loadingDetail: true, healthCare: {} }
    case DETAIL_BRANCH_HEALTHCARE_SUCCESS:
      return { ...state, loadingDetail: false, healthCare: action.payload }
    case DETAIL_BRANCH_HEALTHCARE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload, healthCare: {} }
    case UPDATE_BRANCH_HEALTHCARE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_BRANCH_HEALTHCARE_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_HEALTHCARE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_BRANCH_HEALTHCARE_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_BRANCH_HEALTHCARE_SUCCESS:
      return {
        ...state,
        loadingDelete: false
      }
    case DELETE_BRANCH_HEALTHCARE_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default branchPropertiesReducer
